import React from "react";
import CONFIG from "./config";

const TermsPage = () => {
  return (
    <div>
    <div style={styles.container}>
        <div style={styles.topSection}>
                        <p style={styles.logo}>
                            <a href={`${CONFIG.FRONTEND_URL}`} style={{ textDecoration: "none", color: "inherit" }}>
                            Rili Day</a>
                        </p>
                        <button 
                            style={styles.homeButton}
                            onClick={() => window.location.href = `${CONFIG.FRONTEND_URL}`}
                        >
                        Home Page
                        </button>                                        
        </div>
        <h1 style={styles.title}>Terms and Services</h1>
        <p style={styles.subtitle}>
        <strong>Last Updated:</strong> February 2025
      </p>

      <section style={styles.section}>
        <h2>1. Introduction</h2>
        <p>
          These Terms and Services (<strong>"Terms"</strong>) govern your use of Rili Day
          (<strong>"we," "us," or "our"</strong>) and all features provided on
          www.rili.day. By accessing or using our services, you agree to be bound by
          these Terms.
        </p>
      </section>

      <section style={styles.section}>
        <h2>2. Service Description</h2>
        <p>
          Rili Day provides an online scheduling and appointment management tool that
          helps businesses (<strong>"Business Owners"</strong>) create a public page, manage their calendar, 
          and allow their end customers (<strong>"Customers"</strong>) to book appointments. 
          While we facilitate the booking process, the Business Owner is solely responsible 
          for the content and legitimacy of their public business page.
        </p>
      </section>

      <section style={styles.section}>
        <h2>3. Business Owner Responsibilities</h2>
        <ul style={styles.ul}>
          <li>
            <strong>Account Creation:</strong> Business Owners must provide accurate information 
            upon registration, including valid business details.
          </li>
          <li>
            <strong>Content Compliance:</strong> Any text, images, or other materials 
            posted on a business page must comply with local laws, regulations, 
            and community standards. Rili Day does not review or control the content 
            published by Business Owners.
          </li>
          <li>
            <strong>Legal Obligations:</strong> Business Owners must ensure their 
            appointments, events, or services comply with all relevant local, 
            state, national, or international laws.
          </li>
          <li>
            <strong>Data Ownership:</strong> Business Owners are responsible for 
            protecting any customer data they collect or export from Rili Day. 
            Rili Day is not liable for any misuse of customer data once it is 
            forwarded to a Business Owner.
          </li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2>4. Customer Responsibilities</h2>
        <ul style={styles.ul}>
          <li>
            <strong>Accurate Information:</strong> Customers agree to provide 
            correct and lawful details when booking an appointment. 
            Fictitious names or false contact information are prohibited.
          </li>
          <li>
            <strong>Appropriate Use:</strong> Customers must not abuse the 
            scheduling system by sending spam appointments, harassing 
            communications, or malicious content to a Business Owner.
          </li>
          <li>
            <strong>Local Laws:</strong> Customers are solely responsible for 
            ensuring the content they provide does not violate any local, 
            state, or federal laws.
          </li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2>5. Prohibited Activities</h2>
        <p>
          Users (both Business Owners and Customers) must not engage in:
        </p>
        <ul style={styles.ul}>
          <li>Fraudulent or deceptive practices.</li>
          <li>Uploading or distributing harmful code, viruses, or malware.</li>
          <li>Sending mass unsolicited (spam) communications via Rili Day’s scheduling system.</li>
          <li>Violating intellectual property rights of any third party.</li>
          <li>Any activity that disrupts or interferes with our services.</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2>6. Reporting Misuse</h2>
        <p>
          If you believe a Business Owner or Customer is misusing our service, you may 
          report it to us at <a href="mailto:mail@rili.day">mail@rili.day</a>. We reserve 
          the right to suspend or remove any user or content that violates these Terms or 
          local laws.
        </p>
      </section>

      <section style={styles.section}>
        <h2>7. Intellectual Property</h2>
        <p>
          All intellectual property rights in our platform, including trademarks, 
          service marks, logos, and content (except for user-provided content), 
          remain the exclusive property of Rili Day. Users may not use, copy, 
          or distribute any material from our site without our prior written consent.
        </p>
      </section>

      <section style={styles.section}>
        <h2>8. Disclaimers &amp; Limitation of Liability</h2>
        <ul style={styles.ul}>
          <li>
            <strong>Disclaimer of Warranties:</strong> Our service is provided on an 
            “as is” and “as available” basis. We make no warranties or representations 
            about the reliability, timeliness, or accuracy of the scheduling tool.
          </li>
          <li>
            <strong>Business Owner Liability:</strong> Rili Day is not responsible for any 
            content published by Business Owners or any data usage once it is shared 
            with them. 
          </li>
          <li>
            <strong>Limitations:</strong> To the maximum extent permitted by law, Rili Day 
            shall not be liable for any indirect, incidental, or consequential damages 
            arising out of or in connection with the use or inability to use our services.
          </li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2>9. Termination of Services</h2>
        <p>
          We reserve the right to suspend or terminate any user account (Business Owner 
          or Customer) for violating these Terms, abusing the platform, or engaging in 
          illegal or harmful conduct.
        </p>
      </section>

      <section style={styles.section}>
        <h2>10. Changes to These Terms</h2>
        <p>
          We may update or modify these Terms at any time. We will notify users by posting 
          the amended Terms on our website. Continued use after any changes constitutes 
          acceptance of the new Terms.
        </p>
      </section>

      <section style={styles.section}>
        <h2>11. Contact Us</h2>
        <p>
          If you have any questions about these Terms or our services, please contact us at 
          <a href="mailto:mail@rili.day"> mail@rili.day</a>.
        </p>
      </section>

    </div>
    <div style={styles.footer}>
        <p>
            <a href={`${CONFIG.FRONTEND_URL}/privacy`}>Privacy Policy</a>
            {" "}|{" "}
            <a href={`${CONFIG.FRONTEND_URL}/terms`}>Terms of Service</a>
        </p>
    </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
    color: "#333"
  },
  title: {
    fontSize: "32px",
    marginBottom: "10px"
  },
  subtitle: {
    fontSize: "14px",
    marginBottom: "20px",
    color: "#555"
  },
  section: {
    marginBottom: "20px",
    textAlign: "justify"
  },
  ul: {
    listStyleType: "disc",
    marginLeft: "20px"
  },
  footer: {
    marginTop: "50px",
    padding: "0px",
    backgroundColor: "rgb(226, 218, 195)",
    textAlign: "center",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    fontSize: "12px",
    height: "40px"
  },
  topSection: {
    display: "flex", 
    justifyContent: "space-between", 
    paddingBottom: "20px",
    paddingTop: "10px",
    maxWidth: "800px",
    margin: "0 auto",
    lineHeight: "1.6",
    fontFamily: "Arial, sans-serif",
  },
  logo: {
    fontFamily: "Verdana, sans-serif", // Ensures a sans-serif fallback
    fontWeight: "bold", // Makes the text bold
    fontSize: "24px", // Adjust size as needed
    color: "#2c3e50", // Adjust color as needed
    margin: "0px",
},
homeButton: {
    backgroundColor: "#2c3e50",
    color: "#fff",
    padding: "10px 20px",
    borderRadius: "5px",
    cursor: "pointer"
}
};

export default TermsPage;
